import { apiJson } from '@/api/client'
import type {
  ApproveBlockPayload,
  BlockDetail,
  BlockFilters,
  BlocksListResponse,
  LiftBlockPayload,
  RejectBlockPayload,
  RequestBlockPayload,
} from './types'

export interface ListArgs {
  filters?: BlockFilters
}

function buildSearchParams({ filters = {} }: ListArgs): string {
  const sp = new URLSearchParams()
  for (const v of filters.type ?? []) sp.append('type', v)
  for (const v of filters.status ?? []) sp.append('status', v)
  if (filters.q) sp.set('q', filters.q)
  const s = sp.toString()
  return s ? `?${s}` : ''
}

export function listBlocks(args: ListArgs = {}) {
  return apiJson<BlocksListResponse>(`/blocks${buildSearchParams(args)}`)
}

export function listPendingBlocks() {
  // The cases.block_status enum is
  //   (requested, approved, active, rejected, expired, lifted)
  // — "pending" was never a valid value. The approvals queue
  // surfaces blocks awaiting a maker-checker approval, which is
  // the `requested` state.
  return apiJson<BlocksListResponse>('/blocks?status=requested')
}

export function getBlock(id: string) {
  return apiJson<BlockDetail>(`/blocks/${id}`)
}

export function requestBlock(payload: RequestBlockPayload) {
  return apiJson<{ block: BlockDetail }>('/blocks', {
    method: 'POST',
    body: payload,
  })
}

export function approveBlock(payload: ApproveBlockPayload) {
  return apiJson<{ block: BlockDetail }>(`/blocks/${payload.block_id}/approve`, {
    method: 'POST',
  })
}

export function rejectBlock(payload: RejectBlockPayload) {
  return apiJson<{ block: BlockDetail }>(`/blocks/${payload.block_id}/reject`, {
    method: 'POST',
    body: { reason: payload.reason },
  })
}

export function liftBlock(payload: LiftBlockPayload) {
  return apiJson<{ block: BlockDetail }>(`/blocks/${payload.block_id}/lift`, {
    method: 'POST',
    body: { reason: payload.reason },
  })
}

export function getBvnPepper() {
  return apiJson<{ pepper: string }>('/me/bvn-pepper')
}
